import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lookup',
    standalone: false
})

export class LookupPipe implements PipeTransform {
  transform(id: any, lookups: any[], idProperty = 'value', valueProperty = 'label', defaultValue?: string): string {

    if (!id) {
      return null;
    }

    if (!lookups || !lookups.length) {
      return null;
    }

    let returnValue = defaultValue;

    const results = lookups.filter(o =>
      Object.keys(o)
        .filter(k => k === idProperty)
        .some(k => o[k].includes(id)));

    if (results && results.length > 0) {
      const firstResult = results[0];

      if (firstResult.hasOwnProperty(valueProperty)) {
        returnValue = firstResult[valueProperty];
      }
    }

    return returnValue;
  }
}
